import { rem } from "polished";
import { ThemeKind } from "src/types";

import { createThemeFactory } from "../utils";
import preview from "./assets/preview.jpg";
import previewSmall from "./assets/preview-small.jpg";
import { colorSet, fonts } from "./constants";
import createTemplate from "./create-template";
import blocks from "./resolved-blocks";
import selections from "./selections";

export default createThemeFactory((opts) => ({
  kind: ThemeKind.NOLAN,
  name: "Nolan",
  categories: "Conferences, Summits, Multi-day events",
  smallPreviewUrl: previewSmall,
  previewUrl: preview,
  previewColor: "#D7E1E0",
  blocks,
  selections,
  enabled: true,
  requiresPaymentPlanUpgrade: !opts.advancedFeaturesEnabled,
  colorSet,
  fonts,
  typography: {
    patterns: {
      headingOne: {
        fontSize: rem(64),
        lineHeight: rem(72),
        fontWeight: 700,
        viewport: {
          tablet: {
            fontSize: rem(52),
            lineHeight: rem(60),
          },
          mobile: {
            fontSize: rem(40),
            lineHeight: rem(48),
          },
        },
      },
      headingTwo: {
        fontSize: rem(32),
        lineHeight: rem(42),
        fontWeight: 700,
        viewport: {
          tablet: {
            fontSize: rem(28),
            lineHeight: rem(36),
          },
          mobile: {
            fontSize: rem(24),
            lineHeight: rem(32),
          },
        },
      },
      headingThree: {
        fontSize: rem(24),
        lineHeight: rem(32),
        fontWeight: 700,
        viewport: {
          tablet: {
            fontSize: rem(22),
            lineHeight: rem(30),
          },
          mobile: {
            fontSize: rem(20),
            lineHeight: rem(28),
          },
        },
      },
      headingFour: {
        fontSize: rem(20),
        lineHeight: rem(32),
        fontWeight: 700,
        viewport: {
          tablet: {
            fontSize: rem(19),
            lineHeight: rem(29),
          },
          mobile: {
            fontSize: rem(18),
            lineHeight: rem(26),
          },
        },
      },
      paragraph: {
        fontSize: rem(17),
        lineHeight: rem(32),
        fontWeight: 400,
        viewport: {
          tablet: {
            fontSize: rem(15),
            lineHeight: rem(28),
          },
          mobile: {
            fontSize: rem(14),
            lineHeight: rem(24),
          },
        },
      },
      description: {
        fontSize: rem(14),
        lineHeight: rem(24),
        fontWeight: 400,
        viewport: {
          tablet: {
            fontSize: rem(13),
            lineHeight: rem(22),
          },
          mobile: {
            fontSize: rem(12),
            lineHeight: rem(20),
          },
        },
      },
      labelOne: {
        fontSize: rem(16),
        lineHeight: rem(32),
        fontWeight: 700,
      },
      labelTwo: {
        fontSize: rem(14),
        lineHeight: rem(32),
        fontWeight: 400,
        viewport: {
          tablet: {
            lineHeight: rem(28),
          },
          mobile: {
            lineHeight: rem(24),
          },
        },
      },
    },
  },
  createTemplate,
}));
